module.exports = __webpack_public_path__ + "img/talentpool-nodata.76e7a5d2.svg";